import { Card, Col, Layout, Row, Skeleton, Typography } from "antd";
import React from "react";
import { initLogSlice } from "../Slices/Log.slice";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import routes from "../../../engine/routes";
import ReactJson from "react-json-view";
import dayjs from "../../../utils/dayjs";
import { daysJsFormat } from "../../../utils/constants";
import { ShowDifferences } from "./LogDetail.differences";
import { t } from "i18next";

const { Content, Sider, Header, Footer } = Layout;

export function LogDetail({ unitId, expanded, onClose }) {
  const { log, loading } = useSelector(state => state.log);

  const { init, clear } = initLogSlice({});

  const {
    baseUrl,
    route,
    method,
    user,
    userAgent,
    ipAddress,
    content,
    entityId,
    params,
    query,
    createdAt = "",
    json,
  } = log;

  return (
    <>
      <Typography.Title level={3} className={""}>
        {t("logDetail.title")} - {dayjs(createdAt).format(daysJsFormat.fullMs)}
      </Typography.Title>
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <div>
            <>
              <Card title={<h4>{t("logDetail.infoTitle")}</h4>}>
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <h4>{t("logDetail.resource")}</h4>
                    <span>{baseUrl}</span>
                  </Col>
                  <Col span={8}>
                    <h4>{t("logDetail.method")}</h4>
                    <span>{method}</span>
                  </Col>
                  <Col span={8}>
                    <h4>{t("logDetail.route")}</h4>
                    <span>{route}</span>
                  </Col>
                  <Col span={8}>
                    <h4>{t("logDetail.user")}</h4>
                    <Link to={routes.user(user?._id).detail}>
                      {user?.description?.lastname}{" "}
                      {user?.description?.firstname}
                      <br />
                      {user?.email}
                    </Link>
                  </Col>
                  <Col span={8}>
                    <h4>{t("logDetail.browser")}</h4>
                    <p>{userAgent}</p>
                  </Col>
                  <Col span={8}>
                    <h4>{t("logDetail.ipAddress")}</h4>
                    <span>{ipAddress}</span>
                  </Col>{" "}
                  <Col span={8}>
                    <h4>{t("logDetail.entityId")}</h4>
                    <span>{entityId}</span>
                  </Col>
                  <Col span={8}>
                    <h4>{t("logDetail.queries")}</h4>
                    <span>
                      <ReactJson
                        src={query || {}}
                        collapsed={true}
                        displayArrayKey={false}
                        displayDataTypes={false}
                      />
                    </span>
                  </Col>
                  <Col span={8}>
                    <h4>{t("logDetail.params")}</h4>
                    <span>
                      <ReactJson
                        src={params}
                        collapsed={true}
                        displayArrayKey={false}
                        displayDataTypes={false}
                      />
                    </span>
                  </Col>
                </Row>
              </Card>
              <br />
              <Row>
                <Col span={24}>
                  <Card title={<h4>{t("logDetail.changes")}</h4>}>
                    <ShowDifferences differences={json} />
                  </Card>
                </Col>
                <Col span={24}>
                  <Card title={<h4>{t("logDetail.logContent")}</h4>}>
                    <ReactJson
                      src={json}
                      collapsed={true}
                      displayArrayKey={false}
                      displayDataTypes={false}
                    />
                  </Card>
                </Col>{" "}
              </Row>
            </>
          </div>
        </>
      )}
    </>
  );
}
